// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import './assets/icon/iconfont/iconfont.css'
import axios from "axios";
import store from './vuex/store'
import filters from './config/filters.js'
import VueLazyload from 'vue-lazyload'
import isDefine from './config/isDefine'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import '../static/js/jquery.qqFace.js'
// import vConsole from 'vconsole'
// new vConsole()
import {
  Checkbox,
  CheckboxGroup,
  InputNumber,
  Option,
  Radio,
  Rate,
  Select,
  Table,
  TableColumn,
  Message,
  // MessageBox,
} from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css'
// axios.defaults.withCredentials = true

Vue.config.productionTip = false
Vue.prototype.axios = axios
Vue.prototype.$message = Message
// Vue.prototype.$confirm = MessageBox.confirm
Vue.use(Checkbox)
Vue.use(CheckboxGroup)
Vue.use(InputNumber)
Vue.use(Option)
Vue.use(Radio)
Vue.use(Rate)
Vue.use(Select)
Vue.use(Table)
Vue.use(TableColumn)

Vue.use(isDefine)
Vue.use(VueAwesomeSwiper)
Vue.use(VueLazyload, {
  preLoad: 1.3,
  error: require('../src/assets/icon/loadingerror.jpg'),
  loading: require('../src/assets/icon/play.gif'),
  attempt: 1
})
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js